// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2XPJz","messages":"Chat_messages__BkT5C","dateDivider":"Chat_dateDivider__3nWqP"};